import { render, staticRenderFns } from "./searchComponent.vue?vue&type=template&id=227e1c5e&scoped=true"
import script from "./searchComponent.vue?vue&type=script&lang=js"
export * from "./searchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e1c5e",
  null
  
)

export default component.exports